import React from "react";

const LeftArrow = ({style = {}, size = "36", className = "", fill = "#73788B", viewBox = "0 0 36 36"}) => (
    <svg
        width={size}
        style={style}
        height={size}
        viewBox={viewBox}
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        className={`${className || ""}`}
        xmlnsXlink="http://www.w3.org/1999/xlink"
    >
      <path className="u_fill" d="M15.11 18l12.446 12.445L24 34 8 18 24 2l3.556 3.555L15.11 18z" fill={fill}/>
    </svg>
);

export default LeftArrow;

